const SustainabilityScreen = () => {

    return(
        <p>Sustainability screen</p>
    )

}

export default SustainabilityScreen